// Validate that there is an item without constraints for each slot
const validateConstraints = (config, numberOfSlots) => {
  const { items } = config;
  const slotsWithEmptyConstraint = [];

  if (!items) {
    return new Error('Missing items');
  }

  for (const item of items) {
    const { slot, constraint } = item;
    if (constraint.length === 0 && slotsWithEmptyConstraint.indexOf(slot) < 0) {
      slotsWithEmptyConstraint.push(slot);
    }

    if (slotsWithEmptyConstraint.length === numberOfSlots) {
      return null;
    }
  }

  return new Error('All slots must have at least one item with empty constraints');
};

module.exports = { validateConstraints };



// WEBPACK FOOTER //
// ./common/validation/constraints.js